import React, { useMemo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FixedSizeList as List } from 'react-window';
import WindowedOption from './WindowedOption';
import { isArrayWithLength } from '../../../../helpers';
import { StyledNoMenuOptions } from './styled';

const WindowedMenu = ({
  menuOptions,
  focusedOptionKey,
  formatOptionLabel,
  focusedOptionIndex,
  noOptionsMessage,
  itemSize,
  maxHeight,
  overscanCount,
  handleOnItemsRendered,
}) => {
  const windowListRef = useRef();

  const itemData = useMemo(() => ({
    menuOptions,
    focusedOptionKey,
    formatOptionLabel,
  }), 
  [focusedOptionKey, menuOptions, formatOptionLabel]
  );

  useEffect(() => {
    if (windowListRef.current && focusedOptionIndex > -1) {
      windowListRef.current.scrollToItem(focusedOptionIndex);
    }
  }, [focusedOptionIndex]);

  if (!isArrayWithLength(menuOptions)) {
    return (
      <StyledNoMenuOptions>{noOptionsMessage}</StyledNoMenuOptions>
    );   
  }

  return (
    <List
      className='windowed-list'
      itemData={itemData}
      itemSize={itemSize}
      ref={windowListRef}
      overscanCount={overscanCount}
      itemCount={menuOptions.length}
      onItemsRendered={handleOnItemsRendered}
      itemKey={(index, data) => data.menuOptions[index].key}
      height={Math.min(maxHeight, (menuOptions.length * itemSize))}
    >
      {WindowedOption}
    </List>
  );
};

WindowedMenu.propTypes = {
  menuOptions: PropTypes.array,
  noOptionsMessage: PropTypes.string,
  focusedOptionKey: PropTypes.any,
  overscanCount: PropTypes.number,
  handleOnItemsRendered: PropTypes.func,
  itemSize: PropTypes.number.isRequired,
  maxHeight: PropTypes.number.isRequired,
  focusedOptionIndex: PropTypes.number,
  formatOptionLabel: PropTypes.func.isRequired,
};

export default WindowedMenu;